module.exports = __webpack_public_path__ + "img/app-icon-3.f24da720.svg";